export default __webpack_public_path__ + "static/media/filter.d1ad8a15.svg";